/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//PRODUCT: Modal info slider

let infoIcon = document.querySelector(".product-form__option-icon");
let infoPopup = document.querySelector(".product-modal");
let infoContainer = document.querySelector(".product-modal__content");
let closeIcon = document.querySelector(".product-modal__close-icon");

// adding a click event to all the buttons
if(infoIcon) {
  infoIcon.addEventListener("click", toggleSlider);
}

if(closeIcon) {
  closeIcon.addEventListener("click", toggleSlider);
}

if(infoPopup) {
  infoPopup.addEventListener("click", (e) => {
    if (!e.target.closest(".product-modal__content")) {
      toggleSlider();
    }
  });
}

function toggleSlider() {
  if (infoPopup.classList.contains("show")) {
    infoContainer.classList.toggle("slidein");
    setTimeout(() => {
      infoPopup.classList.toggle("show");
    }, 200);
  } else {
    infoPopup.classList.toggle("show");
    setTimeout(() => {
      infoContainer.classList.toggle("slidein");
    }, 200);
  }
}